import { c as _c } from "react/compiler-runtime";
import { Hint, Tooltip } from '@systemeio/ui';
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import WebhookCreateModal from 'modules/profile/webhooks/components/create-modal';
import WebhookModal from 'modules/profile/webhooks/components/webhook-modal';
import { eventTypeTitleLocoKeys } from 'modules/profile/webhooks/constants/event-type-translation-dictionary';
import { WebhookSettingsLoco } from 'modules/profile/webhooks/constants/webhook-settings-loco';
import { useWebhookSettings } from 'modules/profile/webhooks/hooks/use-webhook-settings';
import { useWebhookSettingsApi } from 'modules/profile/webhooks/hooks/use-webhook-settings-api';
import { WebhookInterface } from 'modules/profile/webhooks/types/webhook-settings-interface';
import React, { useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import TransLoco from 'shared/components/trans-loco';
import { getWebhooksInfoLink } from 'modules/profile/webhooks//utils/get-webhooks-info-link';
const WebhookSettings = () => {
  const $ = _c(84);
  const {
    t
  } = useLocoTranslation();
  const [current, setCurrent] = useState();
  const {
    webhooks,
    mutate,
    isLoading
  } = useWebhookSettings();
  const {
    remove
  } = useWebhookSettingsApi();
  let t0;
  if ($[0] !== t) {
    t0 = t("global.name");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      key: "name",
      header: t0,
      widthPercent: 20
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("global.url");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      key: "url",
      header: t2,
      widthPercent: 40
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.settings.webhook_settings.subscription_count");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t6 => {
      const {
        subscriptions
      } = t6;
      const enabledEvents = subscriptions.filter(_temp);
      const eventsList = enabledEvents.map(s_0 => t(eventTypeTitleLocoKeys[s_0.event])).join(", ");
      if (!eventsList) {
        return null;
      }
      return <Tooltip label={eventsList} className="flex gap-2"><div className="w-[50%] overflow-hidden text-ellipsis">{eventsList}</div><div>{t("dashboard.settings.webhook_settings.subscription_count_caption", {
            number: enabledEvents.length.toString()
          })}</div></Tooltip>;
    };
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = {
      key: "subscriptions",
      header: t4,
      onRender: t5,
      widthPercent: 40
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t6) {
    t7 = [t1, t3, t6];
    $[15] = t1;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const columns = t7;
  let t8;
  if ($[19] !== webhooks) {
    t8 = webhooks && {
      items: webhooks,
      hasMore: false
    } as DataWithPaginationInterface<WebhookInterface>;
    $[19] = webhooks;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const data = t8;
  let t9;
  if ($[21] !== mutate) {
    t9 = async webhook => await mutate(data_0 => [webhook].concat(data_0 ?? []), false);
    $[21] = mutate;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const handleSaveWebhook = t9;
  let t10;
  if ($[23] !== mutate) {
    t10 = async webhook_0 => await mutate(data_1 => data_1?.map(wh => wh.id === webhook_0.id ? webhook_0 : wh), false);
    $[23] = mutate;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const handleSaveEditWebhook = t10;
  let t11;
  if ($[25] !== mutate || $[26] !== remove) {
    t11 = async webhook_1 => {
      await remove(webhook_1.id);
      await mutate(data_2 => data_2?.filter(wh_0 => wh_0.id !== webhook_1.id), false);
    };
    $[25] = mutate;
    $[26] = remove;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const handleRemove = t11;
  let t12;
  if ($[28] !== t) {
    t12 = t(settingsMenuLocoKeys.webhooks);
    $[28] = t;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = [{
      caption: t12,
      isStatic: true
    }];
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== webhooks) {
    t14 = webhooks && {
      count: webhooks.length
    };
    $[32] = webhooks;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      a: <a rel="noreferrer" target="_blank" className="primary-link w-full" href={getWebhooksInfoLink()} />
    };
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t) {
    t16 = <TransLoco t={t} i18nKey="dashboard.user_settings.webhooks.title_hint" components={t15} />;
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t("dashboard.user_settings.webhooks.title_plural");
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t17) {
    t18 = <h1 className="flex h-[42px] items-center whitespace-nowrap">{t17}</h1>;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t16 || $[42] !== t18) {
    t19 = <Hint label={t16}>{t18}</Hint>;
    $[41] = t16;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== handleSaveWebhook) {
    t20 = <WebhookCreateModal onSave={handleSaveWebhook} />;
    $[44] = handleSaveWebhook;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t) {
    t21 = t("dashboard.user_settings.webhooks.caption");
    $[46] = t;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== handleRemove) {
    t22 = {
      onChange: handleRemove
    };
    $[48] = handleRemove;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t) {
    t23 = t("dashboard.user_settings.webhooks.actions.view_logs");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t23) {
    t24 = [{
      isNext: true,
      name: "view",
      caption: t23,
      setHref: _temp2
    }];
    $[52] = t23;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t) {
    t25 = t("global.edit");
    $[54] = t;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = async webhook_3 => setCurrent(webhook_3);
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t25) {
    t27 = [{
      name: "edit",
      caption: t25,
      onActionClick: t26
    }];
    $[57] = t25;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t22 || $[60] !== t24 || $[61] !== t27) {
    t28 = {
      remove: t22,
      openLink: t24,
      custom: t27
    };
    $[59] = t22;
    $[60] = t24;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== columns || $[64] !== data || $[65] !== t21 || $[66] !== t28) {
    t29 = <Table data={data} columns={columns} caption={t21} actions={t28} />;
    $[63] = columns;
    $[64] = data;
    $[65] = t21;
    $[66] = t28;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== data || $[69] !== t14 || $[70] !== t19 || $[71] !== t20 || $[72] !== t29) {
    t30 = <div className="w-full lg:max-w-[65%] xl:max-w-[75%]"><ListingLayout data={data} counter={t14} title={t19} type="compact" customHeaderElement={t20}>{t29}</ListingLayout></div>;
    $[68] = data;
    $[69] = t14;
    $[70] = t19;
    $[71] = t20;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  const t31 = !!current;
  let t32;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = () => setCurrent(undefined);
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== current || $[76] !== handleSaveEditWebhook || $[77] !== t31) {
    t33 = <WebhookModal isOpen={t31} onClose={t32} webhook={current} onSave={handleSaveEditWebhook} />;
    $[75] = current;
    $[76] = handleSaveEditWebhook;
    $[77] = t31;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== isLoading || $[80] !== t13 || $[81] !== t30 || $[82] !== t33) {
    t34 = <SettingsLayout needSave={false} titles={t13} isFetching={isLoading}>{t30}{t33}</SettingsLayout>;
    $[79] = isLoading;
    $[80] = t13;
    $[81] = t30;
    $[82] = t33;
    $[83] = t34;
  } else {
    t34 = $[83];
  }
  return t34;
};
export const getServerSideProps = getBaseServerSideProps(WebhookSettingsLoco, 'global.settings');
export default WebhookSettings;
function _temp(s) {
  return !s.disabledReason;
}
function _temp2(webhook_2) {
  return `/profile/webhook-settings/${webhook_2.id}`;
}